import { IAppState } from '../../store';

export function selectIsChatModalOpen(state: IAppState): boolean {
  return state.chatModal.isOpen;
}
